/**
 * Fixed UI terminology for Organization / Season (not league-configurable).
 */
export const DOMAIN_ORGANIZATION = 'Organization';
export const DOMAIN_ORGANIZATION_LOWER = 'organization';
export const DOMAIN_SEASON = 'Season';
export const DOMAIN_SEASON_LOWER = 'season';
